<template>
  <div>
    <ConfirmationDialog
      :showDialog="showConfirmationDialog"
      :text="getTranslated('_willCreate') + ' ' + totalUbications + ' '  + getTranslated('_lowerUbications')"
      @accept="confirmationDialogAccept"
      @cancel="showConfirmationDialog = false"
    ></ConfirmationDialog>

    <v-navigation-drawer
      :value="isOpen"
      absolute
      right
      width="600px"
      style="z-index: 6; position: fixed"
      :height="dialogHeight"
      touchless
      hide-overlay
      stateless
    >
      <v-card elevation="0" class="ma-7" style ="background-color: transparent;">
        <v-card-title class="text-h5">{{getTranslated('_addLctRacks')}}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="save" v-model="valid" ref="form" style="flex: 1 1 auto">
            <v-select v-model="rackTemplateId" :disabled="loading" :rules="rackTemplateIdRule" :label="getTranslated('_rackBaseTemplate')" item-value="id" item-text="rackTemplateName" :items="rackTemplateList" @change="rackChanged()" :no-data-text="getTranslated('_selectNoData')"></v-select>
            <v-text-field v-model="rackToCreate" :disabled="loading" :rules="requiredRule" type="number" :label="getTranslated('_racksToCreate')" min="0" max="99999"></v-text-field>
            <div v-if="getSelectedRackBays() > 0">
              <v-card v-for="(item,i) in getSelectedRackBays()" :key="i" align="center" class="mb-2 py-1">
                <v-text-field class="mx-5" :label="getTranslated('_order')" disabled v-model="bayProperties[i].order"></v-text-field>
                <v-select class="mx-5" :label="getTranslated('_wmsPositionArea')" v-model="bayProperties[i].codArea" :items="areaList" item-value="codArea" :rules="requiredRule">
                  <template v-slot:selection="data">
                    {{ data.item.codArea }} - {{ data.item.name }}
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.codArea }} - {{ data.item.name }}
                  </template>
                </v-select>
                <v-select class="mx-5" :label="getTranslated('_wmsPositionZone')" v-model="bayProperties[i].codZona" :items="zonaList" item-value="codZone" :rules="requiredRule">
                  <template v-slot:selection="data">
                    {{ data.item.codZone }} - {{ data.item.name }}
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.codZone }} - {{ data.item.name }}
                  </template>
                </v-select>
                <v-select class="mx-5" :label="getTranslated('_wmsPositionType')" v-model="bayProperties[i].codUbi" :items="positionTypeList" item-value="codUbi" item-text="name" :rules="requiredRule"></v-select>
              </v-card>
            </div>
            <v-progress-linear
              v-show="loading"
              height="20"
              :value="(currentUbication/totalUbications)*100"
            >
            <template v-slot:default>
              <span v-if="currentUbication !== totalUbications" class="black--text">{{currentUbication + ' / '+ totalUbications}}</span>
              <span v-else class="black--text">{{getTranslated('_savingInDatabase')}}</span>
            </template>
            </v-progress-linear>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top :disabled="valid" transition="slide-y-reverse-transition">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn color="primary" text :disabled="!valid" :loading="loading" @click.stop="openConfirmationDialog()">{{getTranslated('_save')}}</v-btn>
              </div>
            </template>
            <span>{{getTranslated('_saveRequiredValuesAlert')}}</span>
          </v-tooltip>
          <v-btn color="primary" text @click.stop="cancel" :disabled="loading">{{getTranslated('_cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-navigation-drawer>
    <v-overlay :value="isOpen" z-index="5">
    </v-overlay>
  </div>
</template>
<script>
import lctracktemplatesService from '../services/Lct_RackTemplatesService.js'
import lctracksService from '../services/Lct_RacksService.js'
const ConfirmationDialog = () => import('../components/ConfirmationDialog.vue')

export default {
  components: {
    ConfirmationDialog
  },
  name: 'Lct_RackEditionDialog',
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    translations: Array,
    aisleRowId: String
  },
  data () {
    return {
      title: '',
      valid: false,
      requiredRule: [v => !!v || this.getTranslated('_required')],
      rackTemplateIdRule: [v => !!v || this.getTranslated('_required'), v => this.rackTemplateIsValid(v) || this.getTranslated('_LctRackTemplateNotValid')],
      dialogHeight: window.innerHeight,
      loading: false,
      rackTemplateList: [],
      rackTemplateId: '',
      rackToCreate: '',
      showConfirmationDialog: false,
      totalUbications: '',
      currentUbication: 0,
      bayProperties: [],
      areaList: [],
      zonaList: [],
      positionTypeList: []
    }
  },
  computed: {
    isOpen: {
      get () {
        return this.openDialog
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    async save () {
      this.loading = true
      let rack = {
        aisleRowId: this.aisleRowId,
        rackTemplateParentId: this.rackTemplateId,
        rackToCreate: this.rackToCreate,
        ubicationProperties: this.bayProperties
      }
      await lctracksService.createLct_Rack(rack).then(res => {
        var notification = {
          color:
            res.request.status === 200 || res.request.status === 201
              ? 'green'
              : 'red',
          message:
            res.request.status === 200 || res.request.status === 201
              ? this.getTranslated('_LctRackSaved')
              : this.getTranslated('_LctRackSavedError')
        }
        this.loading = false
        this.$emit('saved', notification)
        this.cancel()
      })
    },
    async getTotalUbications () {
      let rack = {
        aisleRowId: this.aisleRowId,
        rackTemplateParentId: this.rackTemplateId,
        rackToCreate: this.rackToCreate
      }
      let response = await lctracksService.getTotalUbications(rack)
      this.totalUbications = response.data
    },
    async getCreatedUbications () {
      let response = await lctracksService.getCreatedUbications()
      return response.data
    },
    async loadLists () {
      await lctracksService.getAreaList().then(response => {
        this.areaList = response.data
      })
      await lctracksService.getZonaList().then(response => {
        this.zonaList = response.data
      })
      await lctracksService.getPositionTypeList().then(response => {
        this.positionTypeList = response.data
      })
    },
    cancel () {
      this.loading = false
      this.isOpen = false
      this.$refs.form.reset()
    },
    getTranslated (key) {
      var translation = this.translations.filter(element => element.key === key)
      if (translation.length > 0) {
        return translation[0].translation
      } else {
        return 'Translation Error: ' + key
      }
    },
    handleResize (event) {
      this.dialogHeight = window.innerHeight
    },
    async getRackTemplateList () {
      let response = await lctracktemplatesService.get()
      this.rackTemplateList = response.data
    },
    initialize () {
      this.getRackTemplateList()
      this.loadLists()
    },
    async confirmationDialogAccept () {
      this.currentUbication = 0
      this.showConfirmationDialog = false
      let activeInterval = true
      this.save().then(() => {
        activeInterval = false
      })
      let self = this
      let interval = setInterval(async function () {
        let response = await self.getCreatedUbications()
        self.currentUbication = response
        if (!activeInterval || self.currentUbication === self.totalUbications) {
          clearInterval(interval)
        }
      }, 100)
    },
    async openConfirmationDialog () {
      await this.getTotalUbications()
      this.showConfirmationDialog = true
    },
    rackTemplateIsValid (rackTemplateId) {
      let rackTemplate = this.rackTemplateList.find(x => x.id === rackTemplateId)
      if (rackTemplate !== undefined && rackTemplate.rackTemplateBayQuantity <= rackTemplate.bays.length) {
        return true
      }
      return false
    },
    getSelectedRackBays () {
      let rackTemplate = this.rackTemplateList.find(x => x.id === this.rackTemplateId)
      if (rackTemplate !== undefined) {
        return rackTemplate.bays.length
      } else {
        return 0
      }
    },
    rackChanged () {
      let bayCount = this.getSelectedRackBays()
      if (bayCount > 0) {
        for (let index = 0; index < bayCount; index++) {
          this.bayProperties[index] = {
            order: index,
            codArea: '',
            codZona: '',
            codUbi: ''
          }
        }
        this.bayProperties = this.bayProperties.slice().reverse()
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.initialize()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
